import { Component, OnInit, Inject, signal } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-delete-rides',
  templateUrl: './delete-rides.component.html',
  styleUrls: ['./delete-rides.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatIcon,
    MatDialogActions,
    MatButton,
  ],
})
export class DeleteRidesComponent implements OnInit {
  deleteForm: UntypedFormGroup;
  deleteRideTxt = signal<string | null>(null);
  deleteRideTxtError = signal<string | null>(null);
  organisationId = localStorage.getItem('orgId');
  deletingRides = signal(false);
  dateCheckPass = signal(false);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteRidesComponent>,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.deleteForm = this.fb.group({
      deleteRidesFrom: [],
      deleteRidesTo: [],
    });
    const now = new Date();
    const oneMonthEarlier = new Date(now.setMonth(now.getMonth() - 1));
    const oneDayEarlier = new Date(
      new Date(now.setDate(now.getDate() - 1)).setMonth(now.getMonth() + 1),
    );
    this.deleteForm.patchValue({
      deleteRidesFrom: oneMonthEarlier,
      deleteRidesTo: oneDayEarlier,
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  async deleteRidesInRange() {
    this.deletingRides.set(true);
    const deleteRidesFrom = this.deleteForm.value.deleteRidesFrom;
    const deleteRidesTo = this.deleteForm.value.deleteRidesTo;
    console.log('deleteRidesFrom', deleteRidesFrom);
    try {
      const httpCall = (await this.http
        .post(`${environment.functionsUrl}/httpDeleteRidesFrom`, {
          organisationId: this.organisationId,
          deleteRidesFrom: deleteRidesFrom ? deleteRidesFrom.setHours(0, 0, 0, 0) : null,
          deleteRidesTo: deleteRidesTo ? deleteRidesTo.setHours(0, 0, 0, 0) : null,
        })
        .toPromise()) as { message: string };
      console.log('httpCall', httpCall);
      if (httpCall.message === 'succeed') {
        this.snackBar.open('Ritten zijn succesvol verwijderd.', 'X', {
          duration: 5000,
        });
        this.dialogRef.close();
      }
    } catch (e) {
      console.error(e);
    }
    this.dateCheckPass.set(true);
    this.deleteRideTxt.set(null);
    this.deleteRideTxtError.set(null);
    this.deletingRides.set(false);
  }

  checkRange() {
    console.log(
      'this.organisationForm.value.deleteRidesFrom',
      this.deleteForm.value.deleteRidesFrom,
    );
    const deleteRidesFrom = this.deleteForm.value.deleteRidesFrom;
    const deleteRidesTo = this.deleteForm.value.deleteRidesTo;
    if (!deleteRidesFrom && !deleteRidesTo) {
      this.deletingRides.set(false);
      return this.snackBar.open('Kies de periode waarin je ritten wilt verwijderen.', 'X', {
        duration: 5000,
      });
    }
    if (!deleteRidesFrom) {
      this.deleteRideTxtError.set(null);
      this.deleteRideTxt.set(`Tot ${deleteRidesTo.toLocaleDateString()}`);
    }
    if (!deleteRidesTo) {
      this.deleteRideTxtError.set(null);
      this.deleteRideTxt.set(`Vanaf ${deleteRidesFrom.toLocaleDateString()}`);
    }
    if (deleteRidesFrom && deleteRidesTo) {
      this.deleteRideTxtError.set(null);
      this.deleteRideTxt.set(
        `Vanaf ${deleteRidesFrom.toLocaleDateString()} tot ${deleteRidesTo.toLocaleDateString()}`,
      );
      if (deleteRidesFrom > deleteRidesTo) {
        this.dateCheckPass.set(false);
        this.deleteRideTxtError.set(`De vanaf datum mag niet later zijn dan de tot datum`);
        return;
      }
    }
    this.dateCheckPass.set(true);
    console.log(
      'this.organisationForm.value.deleteRidesFrom2',
      this.deleteForm.value.deleteRidesFrom,
    );
  }

  cancelRange() {
    this.deleteRideTxt.set(null);
    this.deleteRideTxtError.set(null);
    this.dateCheckPass.set(false);
    const now = new Date();
    const oneMonthEarlier = new Date(now.setMonth(now.getMonth() - 1));
    const oneDayEarlier = new Date(
      new Date(now.setDate(now.getDate() - 1)).setMonth(now.getMonth() + 1),
    );
    this.deleteForm.controls.deleteRidesFrom.setValue(oneMonthEarlier);
    this.deleteForm.controls.deleteRidesTo.setValue(oneDayEarlier);
  }

  close() {
    this.dialogRef.close();
  }
}
